import { FormActions } from "./FormActions";

export const HasWorkers = {
    choseWorker: (id) => {
        const workerRow = $(`.worker-row[data-id=${id}]`);
        const workerNameNode = workerRow.find('.worker-name').first().clone();
        workerNameNode.find('.worker-phone').remove();
        const workerName = workerNameNode.text().replace(/\s+/g, ' ').trim();
        if (!workerRow.parents('.form-group').find('.selected-workers').find('.selected-worker').length) {
            workerRow.parents('.form-group').find('.selected-workers').text('');
        }
        try {
            workerRow.parents('.form-group').find('.selected-workers').append(window.chosedWorker(id, workerName));
        } catch {
            return;
        }

    },
    deleteWorker: (id) => {
        const workerRow = $(`.worker-row[data-id=${id}]`);
        $(`.selected-worker[data-id=${id}]`).remove();
        workerRow.find(`input[type=checkbox]`).prop('checked', false);
        if (!workerRow.parents('.form-group').find('.selected-workers').find('.selected-worker').length) {
            workerRow.parents('.form-group').find('.selected-workers').text('Select');
        }
    },
    assingWorkers(callback=() => window.location.reload(), parent = '') {
        const formSelector = parent || `#assing_workers-${this.entityClass}`;
        const data = { workers: this.collectWorkersInForm(parent) };
        $(`${formSelector} [data-worker-warning-context]`).each(function() {
            data[$(this).attr('name')] = $(this).val();
        });

        $.ajax({
            url: `${this.urlRoot}/${this.id}/assing-workers`,
            method: 'POST',
            data,
            success: () => {
                callback();
            }
        });
    },

    completeForm(formId, options={}, self=null) {
        self = self ?? this;
        if (self.id == null) {
            FormActions.completeForm(formId, options, self);
        } else {
            const entityInfo = self.read();
            FormActions.completeForm(formId, null, self);
            for (let workerId of entityInfo.workers) {
                self.choseWorker(workerId);
                $(`.worker-row[data-id=${workerId}] input[type=checkbox]`).prop('checked', true);
            }
        }
    },

    collectWorkersInForm: (parent ='') => {
        const workersIds = [];
        const selectedWorkers = $(`${parent} .workers-select .worker-row input[type=checkbox]:checked`);
        for (let selectedWorker of selectedWorkers) {
            workersIds.push($(selectedWorker).val());
        }
        return workersIds;
    },

    addWorkerComment(commentText, callback=()=>{}) {
        $.ajax({
            url: '/worker-cabinet/comment/create',
            data: { jobId: this.id, type: this.entityClass, commentText,  },
            method: 'POST',
            success: callback
        });
    },

    /**
     * Функция для получения списка воркер для периода времени указанного в фильтре.
     * @param {Array} data
     */
    getWorkersForFilter(data) {
        if (this.entityClass == 'order') {
            $.ajax({
                url: `${this.urlRoot}/get-workers`,
                method: 'POST',
                data: data,
                success: (response) => {
                    this.addWorkersInFilter(response,data);
                }
            });
        }
    },

    /**
     * Обновление фильтра воркеров.
     * @param {Array} data
     */
    addWorkersInFilter(data, filter_data){
        $('.filter').find('select#worker').html('');
        data.forEach(element => {
            let selected = '';
            if (filter_data.worker == element.id) {
                selected = 'selected';
            }
            $('.filter').find('select#worker').append(`<option value="${element.id}"${selected}>${element.title}</option>`);
        });
    }
}
